<template>
	<v-overlay :value="hasError" :dark="false" z-index="9999">
		<v-card max-width="800" class="pa-4">
			<v-card-text class="text-center">
				<v-icon color="primary" large>mdi-emoticon-sad-outline</v-icon>

				<div class="text-center">
					<span class="text-h2 font-weight-thin"
						>Oops! We've encountered an unexpected error. Please
						refresh the page and try again. If the error persists,
						please contact your Iris Administrator</span
					>
				</div>

				<div v-if="isSuperAdmin" class="text-center mt-4">
					{{ error }}
				</div>
			</v-card-text>

			<v-card-actions style="justify-content: center">
				<v-btn color="primary" autofocus @click.prevent="onOk">
					OK
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-overlay>
</template>
<script>
import { mapGetters } from 'vuex';
import { GeneralGetters, AuthGetterTypes } from '../../store/getters';
import { GeneralActions } from '../../store/actions';
export default {
	name: 'ErrorOverlay',
	computed: {
		...mapGetters({
			hasError: [GeneralGetters.HAS_ERROR],
			error: [GeneralGetters.GET_ERROR],
			isSuperAdmin: [AuthGetterTypes.IS_SUPERADMIN],
		}),
	},
	methods: {
		onOk() {
			this.$store.dispatch(GeneralActions.CLEAR_ERROR);
		},
	},
};
</script>
